// Laad-placeholder die de vorm van een SessionCard nabootst, zodat de lijst niet
// "inklapt" na het laden (voorkomt layout shift). De shimmer komt uit de
// `.skeleton`-helper in global.scss; prefers-reduced-motion neutraliseert de
// animatie automatisch.
export default function SkeletonCard() {
  return (
    <div className="w-full border border-line rounded-lg py-3 px-4 flex flex-col gap-2.5 bg-surface shadow-e1">
      {/* Rij 1: naam + badge */}
      <div className="flex items-center justify-between gap-2">
        <div className="skeleton h-[17px] w-[45%] rounded" />
        <div className="skeleton h-[18px] w-[64px] rounded-[20px]" />
      </div>
      {/* Rij 2: tijd + stat-chips */}
      <div className="flex items-center justify-between gap-2">
        <div className="skeleton h-[13px] w-[38%] rounded" />
        <div className="flex gap-4">
          <div className="skeleton h-[26px] w-[40px] rounded" />
          <div className="skeleton h-[26px] w-[40px] rounded" />
          <div className="skeleton h-[26px] w-[40px] rounded" />
        </div>
      </div>
    </div>
  );
}
